import { render, staticRenderFns } from "./AppSettingsTab.vue?vue&type=template&id=037490c3&"
import script from "./AppSettingsTab.vue?vue&type=script&lang=js&"
export * from "./AppSettingsTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "AppSettingsTab.vue"
export default component.exports